module.exports = __webpack_public_path__ + "static/media/icon-delete.e530ac73.svg";